import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';

export const ExtendedTwirlSVG = () => {
  const { RiveComponent } = useRive({
    src: '/animations/theleap.riv',
    stateMachines: 'CenterSlidingWiggler',
    autoplay: true,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.CenterLeft,
    }),
  });

  return (
    <div className="pt-8 w-full">
      <RiveComponent className="w-full h-24 sm:h-48" />
    </div>
  );
};
